import api from '../../../lib/Api'
import * as actions from './actions'
import { addNotification } from '../../notifications'

export const fetchAndHandlePreviewDeleteUser = deleteUserParameters => {
  return async function(dispatch) {
    dispatch(actions.fetchingPreviewDeleteUser())
    const { userEmail } = deleteUserParameters

    if (userEmail) {
      try {
        const response = await api.get(
          `/licenseuserrole/DeleteUserPreview?email=${encodeURIComponent(
            userEmail,
          )}`,
        )
        const data = response.data !== '' ? response.data : null
        dispatch(actions.fetchingPreviewDeleteUserSuccess(data))
      } catch (error) {
        const { response } = error
        const { data } = response || {}
        const { detail } = data || {}

        const errorMessage = detail || error.toString()
        dispatch(
          addNotification({
            color: 'danger',
            text: errorMessage,
          }),
        )
        dispatch(actions.fetchingPreviewDeleteUserError(errorMessage))
      }
    } else {
      dispatch(
        actions.fetchingPreviewDeleteUserError('missing userEmail to delete'),
      )
    }
  }
}

export const HandleDeleteUser = deleteUserParameters => {
  return async function(dispatch) {
    dispatch(actions.deletingUser())
    const { userEmail } = deleteUserParameters

    if (userEmail) {
      try {
        const response = await api.delete(
          `/profile/deleteUser/${encodeURIComponent(userEmail)}`,
        )

        dispatch(
          addNotification({
            color: 'success',
            text: `You have sucessfully deleted ${userEmail} from the system`,
          }),
        )
        const data = response.data !== '' ? response.data : null
        dispatch(actions.deletingUserSuccess(data))
      } catch (error) {
        const { response } = error
        const { data } = response || {}
        const { detail } = data || {}
        const errorMessage = detail || error.toString()
        dispatch(
          addNotification({
            color: 'danger',
            text: `${errorMessage} ${userEmail} was not deleted from the system`,
          }),
        )
        dispatch(actions.deletingUserError(errorMessage))
      }
    } else {
    }
  }
}
